import type { MeetingDirectoryUser } from "./teamAccess";
const normalized = (value: string) =>
  value.trim().toLowerCase().replace(/\s+/g, " ");
export function participantIdentityKey(user: MeetingDirectoryUser) {
  const name = normalized(`${user.firstName} ${user.lastName}`);
  if (normalized(user.role) === "super_admin" && name)
    return `protected-founder:${name}`;
  if (user.email.trim()) return `email:${normalized(user.email)}`;
  const employment = [
    normalized(user.role),
    normalized(user.department),
    normalized(user.jobTitle),
  ].join("|");
  return `employee:${name}|${employment}`;
}
export function uniqueMeetingDirectory(users: MeetingDirectoryUser[]) {
  const byId = new Map<string, MeetingDirectoryUser>();
  for (const user of users) if (!byId.has(user.id)) byId.set(user.id, user);
  const byIdentity = new Map<string, MeetingDirectoryUser>();
  for (const user of byId.values()) {
    const key = participantIdentityKey(user),
      current = byIdentity.get(key);
    if (!current || (!current.email && user.email)) byIdentity.set(key, user);
  }
  return [...byIdentity.values()];
}
